module.exports = __webpack_public_path__ + "static/media/avatar.65b79a1e.jpg";